import { MOBILE_HOME_ITEM_TYPES } from '@shared/types/frontend/tables';
import { useMemo } from 'react';
export const useMobileHomeList = ({
  mode,
  results,
  recentlyListedToken,
  recentItems,
  timeFrame,
  shouldOnboard,
  showReferralInput,
  hasUsername,
  keyword,
  loadingModes,
  wildWest,
  allTokens,
  subMemeData,
  network,
  isUserWithFunds,
  isLoadingAssetData,
  assetData,
  showUnverifiedWarning
}) => {
  return useMemo(() => {
    const items = [];
    // Special case for 'saved' mode
    if (mode === 'saved') {
      if (loadingModes.loadingSavedTokens) {
        items.push({
          type: MOBILE_HOME_ITEM_TYPES.LOADING,
          height: 150
        });
      } else {
        // Saved mode header with back and clear buttons
        items.push({
          type: MOBILE_HOME_ITEM_TYPES.SAVED_HEADER,
          height: 45
        });
        // Add saved token results
        if ((results === null || results === void 0 ? void 0 : results.length) > 0) {
          results.forEach(result => {
            items.push({
              type: MOBILE_HOME_ITEM_TYPES.TOKEN_RESULT,
              height: 68,
              data: {
                searchResult: result,
                tokenItem: result.token
              }
            });
          });
        }
        return items;
      }
    }
    // Safe Search switch
    if (mode !== '' && mode !== 'hot') {
      items.push({
        type: MOBILE_HOME_ITEM_TYPES.SAFE_SEARCH,
        height: 60
      });
    }
    if (mode === 'search' && wildWest) {
      items.push({
        type: MOBILE_HOME_ITEM_TYPES.SEARCH_WARNING,
        height: 115
      });
    }
    // Recent Results
    if ((mode === 'recent' || mode === 'memes' || mode === 'native' || mode === 'top' || mode === 'gainers' || mode === 'new' || mode === 'cash') && recentItems && recentItems.length > 0) {
      items.push({
        type: MOBILE_HOME_ITEM_TYPES.RECENT_RESULTS,
        height: 115,
        data: {
          recentItems
        }
      });
    }
    // User Funds section
    if (!shouldOnboard && !showReferralInput && hasUsername && (mode === '' || mode === 'hot')) {
      items.push({
        type: MOBILE_HOME_ITEM_TYPES.USER_FUNDS,
        height: 75,
        data: {
          isUserWithFunds,
          isLoadingAssetData,
          keyword,
          assetData
        }
      });
    }
    // Normie Categories
    if (mode === 'recent' || mode === 'memes' || mode === 'native' || mode === 'top' || mode === 'gainers' || mode === 'new' || mode === 'cash' && keyword === '') {
      items.push({
        type: MOBILE_HOME_ITEM_TYPES.NORMIE_CATEGORIES,
        height: 55
      });
    }
    // Warning Message
    // if (mode === 'hot' || mode === 'gainers' || mode === 'new') {
    //   items.push({ type: MOBILE_HOME_ITEM_TYPES.WARNING_MESSAGE, height: 110 });
    // }
    // Meme Mode
    if (mode === 'memes' || mode === 'recent') {
      items.push({
        type: MOBILE_HOME_ITEM_TYPES.MEME_MODE,
        height: 55
      });
    }
    // Recently Listed section
    if (mode === '' || mode === 'hot') {
      items.push({
        type: MOBILE_HOME_ITEM_TYPES.RECENTLY_LISTED_HEADER,
        height: 54
      });
      items.push({
        type: MOBILE_HOME_ITEM_TYPES.TOKEN_RESULT,
        height: 115,
        data: {
          searchResult: recentlyListedToken,
          tokenItem: recentlyListedToken === null || recentlyListedToken === void 0 ? void 0 : recentlyListedToken.token,
          isRecentlyListed: true
        }
      });
    }
    // Top Gainers section
    if (mode === '' || mode === 'hot') {
      items.push({
        type: MOBILE_HOME_ITEM_TYPES.TOP_GAINERS,
        height: 125,
        data: {
          timeFrame,
          subMemeData,
          loading: loadingModes.gainerLoading
        }
      });
    }
    // Trending title
    if (mode === '' || mode === 'hot') {
      items.push({
        type: MOBILE_HOME_ITEM_TYPES.TRENDING_TITLE,
        height: 55
      });
    }
    if (loadingModes.isLoading && mode === 'search' || loadingModes.subMemeLoading && mode === 'memes' || loadingModes.nativeTokensDataLoading && mode === 'native' || loadingModes.gainerLoading && mode === 'gainers' || loadingModes.topLoading && mode === 'top' || loadingModes.trendingLoading && mode === 'hot' || loadingModes.loserLoading && mode === 'losers' || loadingModes.newLoading && mode === 'new' || loadingModes.subMemeLoading && mode === '') {
      items.push({
        type: MOBILE_HOME_ITEM_TYPES.LOADING,
        height: 150
      });
    } else if (mode === 'cash') {
      items.push({
        type: MOBILE_HOME_ITEM_TYPES.CASH_RESULTS,
        height: 240
      });
    } else if (mode === 'launchpad') {
      items.push({
        type: MOBILE_HOME_ITEM_TYPES.LAUNCHPAD,
        height: 450
      });
    } else {
      if ((results === null || results === void 0 ? void 0 : results.length) > 0) {
        if (mode === 'top') {
          items.push({
            type: MOBILE_HOME_ITEM_TYPES.TOP_10_HEADER,
            height: 30
          });
        }
        let resultsToList = results;
        // Remove the recently listed token from the results if mode is ''
        if (mode === '') {
          resultsToList = results.slice(1);
        }
        if (mode === 'hot' && showUnverifiedWarning) {
          items.push({
            type: MOBILE_HOME_ITEM_TYPES.UNVERIFIED_WARNING,
            height: 125
          });
        } else {
          resultsToList.forEach(result => {
            items.push({
              type: MOBILE_HOME_ITEM_TYPES.TOKEN_RESULT,
              height: 68,
              data: {
                searchResult: result,
                tokenItem: result.token,
                isTop10: mode === 'top'
              }
            });
          });
        }
        if (mode === 'top' && allTokens) {
          items.push({
            type: MOBILE_HOME_ITEM_TYPES.ALL_TOKENS_HEADER,
            height: 30
          });
          allTokens.forEach(result => {
            items.push({
              type: MOBILE_HOME_ITEM_TYPES.TOKEN_RESULT,
              height: 68,
              data: {
                searchResult: result,
                tokenItem: result.token
              }
            });
          });
        }
        if (mode === 'search' && !wildWest) {
          items.push({
            type: MOBILE_HOME_ITEM_TYPES.LOW_VOLUME_BUTTON,
            height: 50
          });
        }
      } else {
        items.push({
          type: MOBILE_HOME_ITEM_TYPES.NO_RESULTS,
          height: 240
        });
      }
    }
    return items;
  }, [mode, results, recentlyListedToken, recentItems, timeFrame, shouldOnboard, showReferralInput, hasUsername, keyword, loadingModes, wildWest, allTokens, subMemeData, network, isUserWithFunds, isLoadingAssetData, assetData, showUnverifiedWarning]);
};